import { Base, Component, Inject, Mixins } from '@/vue-property-decorator'
import { GetCssVarManager } from '@/views/game/components/gameCardSuit/components/baseCssVarProvide'
import { _OuterBoxBase as OuterBoxBase } from './cssVar/outerBoxBase'
import { _OuterBoxDefault as OuterBoxDefault } from './cssVar/outerBoxDefault'
import { _OuterBoxLarger as OuterBoxLarger } from './cssVar/outerBoxLarger'
import { _OuterBoxSmall as OuterBoxSmall } from './cssVar/outerBoxSmall'
import { VerticalProps } from '../../components/basePropsConfig'
import BaseCssVarInject from '../../../../components/baseCssVarInject'
import style from './style.module.scss'
export type OuterBoxCssVarManager = GetCssVarManager<OuterBoxBase>
export { OuterBoxBase, OuterBoxDefault, OuterBoxLarger, OuterBoxSmall }
/** 收藏图标 后面可能要扩展出未收藏和已收藏两种状态,后面再说*/
@Component<OuterBox>({
  name: 'OuterBox'
})
export default class OuterBox extends Mixins<
  Base<unknown, unknown, { onClick: () => void }>,
  BaseCssVarInject<OuterBoxBase>
>(Base, BaseCssVarInject) {
  /** 获得默认样式 */
  public static getCssVarDefault = () => new OuterBoxDefault()
  /** 获得大号样式 */
  public static getCssVarLarger = () => new OuterBoxLarger()
  /** 获得小号样式 */
  public static getCssVarSmall = () => new OuterBoxSmall()

  @Inject() cardProps!: Required<VerticalProps>

  render() {
    const { isMaintain, isHoverMove, isAtSwiper, atSwiperDomId } =
      this.cardProps
    return (
      <div
        class={{
          [style['outer-box']]: true,
          [style[`type-${this.finialCssType}`]]: Boolean(this.finialCssType)
        }}
      >
        <my-img
          options={{
            type: 'div',
            lazy: !isAtSwiper,
            immediate: isAtSwiper
          }}
          src=""
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          //@ts-ignore
          role="OuterBox"
          syncGroupsSrc={isAtSwiper}
          syncGroupsWrapId={atSwiperDomId}
          class={{
            ['outer-box-main']: true,
            [style['outer-box-main']]: true,
            [style['hover-move-top']]: !isMaintain && isHoverMove
          }}
          onClick={() => this.$emit('click')}
        >
          {this.$slots.default}
        </my-img>
      </div>
    )
  }
}
